import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { ITableLargeColumnConfig } from 'projects/common/src/app/interfaces/table/table-large-column-config';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';

@Component({
  selector: 'app-modal-report',
  templateUrl: './modal-report.component.html',
  styleUrls: ['./modal-report.component.scss'],
})
export class ModalReportComponent implements OnInit {
  @Input() public tableData: any;
  public tableConfig: ITableConfig;

  constructor(public activeModal: NgbActiveModal, private tableService: TableConfigService) {}

  public ngOnInit(): void {
    this.setTableDetailReport(this.tableData);
  }

  public setTableDetailReport(tableData: any): void {
    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'machineName', isLargeColumn: true, flexGrow: 0.5, customPadding: '6px 0px 0px 8px' },
      { field: 'shiftDate', isLargeColumn: true, flexGrow: 0.6, customPadding: '6px 0px 0px 3px' },
      { field: 'shiftName', isLargeColumn: true, flexGrow: 0.3, customPadding: '6px 0px 0px 3px' },
      { field: 'cabinetStart', isLargeColumn: true, flexGrow: 0.5, customPadding: '6px 0px 0px 3px' },
      { field: 'startedAt', isLargeColumn: true, flexGrow: 0.6, customPadding: '6px 0px 0px 3px' },
      { field: 'cabinetEnd', isLargeColumn: true, flexGrow: 0.5, customPadding: '6px 0px 0px 3px' },
      { field: 'finishedAt', isLargeColumn: true, flexGrow: 0.6, customPadding: '6px 0px 0px 3px' },
      { field: 'duration', isLargeColumn: true, flexGrow: 0.5, customPadding: '6px 0px 0px 3px' },
      { field: 'stretchTypeName', isLargeColumn: true, flexGrow: 0.5, customPadding: '6px 0px 0px 3px' },
    ];
    const excludeColumns = ['tagId', 'durationAtSeconds'];
    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns,
      customLargeColumns,
      replaceColumnName: [
        { prevName: 'shiftDate', newName: 'Date' },
        { prevName: 'duration', newName: 'Duración' },
        { prevName: 'cabinetStart', newName: 'Inicio Tramo' },
        { prevName: 'startedAt', newName: 'Fecha Inicio' },
        { prevName: 'cabinetEnd', newName: 'Fin Tramo' },
        { prevName: 'finishedAt', newName: 'Fecha Final' },
        { prevName: 'stretchTypeName', newName: 'Tipo Tramo' },
      ],
    };
    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns,
      customLargeColumns,
      dateConfig: [
        { field: 'shiftDate', format: 'date-time' },
        { field: 'startedAt', format: 'date-time' },
        { field: 'finishedAt', format: 'date-time' },
      ],
    };

    const header = this.tableService.setHeaderConfig(headerParams);
    const dataset = this.tableService.setDatasetConfig(datasetParams);

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset }), 0);
  }
}
